@if (promptsData) {
<div class="generic-prompts-container">
  <div class="top-row">
    <div class="summary-card">
      <app-composite-score-widget [compositeScore]="totalGenericPrompts" [title]="'Total generic prompts'" [size]="'medium'">
      </app-composite-score-widget>
      <p>
        Your brand is recommended by LLMs {{ genericRecommendedPct }}% of the time for generic
        and {{ brandedRecommendedPct }}% for branded
      </p>
    </div>
    <div class="chart-card">
      <h3>Prompts by brand</h3>
      @if (chartResults.length > 0) {
      <app-bar-line-combo-chart
        [view]="view"
        [results]="chartResults"
        [lineChart]="chartLineSeries"
        [barBrandName]="barBrandName"
        [xAxis]="true"
        [yAxis]="true"
        [legend]="true"
        [showGridLines]="true"
        [animations]="true"
        [showXAxisLabel]="true"
        [showYAxisLabel]="true"
        [xAxisLabel]="'Prompt types'"
        [yAxisLabel]="'Count'">
      </app-bar-line-combo-chart>
      }
    </div>
  </div>

  @if (tableRows.length > 0) {
  <div class="table-card">
    <table>
      <thead>
        <tr>
          <th>Brands</th>
          @for (c of tableColumns; track c) {
          <th>{{ getColumnLabel(c) }}</th>
          }
        </tr>
      </thead>
      <tbody>
        @for (row of tableRows; track row.brand) {
        <tr>
          <td>{{ row.brand }}</td>
          @for (c of tableColumns; track c) {
          <td>{{ formatPercentCell(row[c]) }}</td>
          }
        </tr>
        }
      </tbody>
    </table>
  </div>
  }

  @if (getGrowingPromptCategories().length > 0) {
  <div class="growing-prompts-section">
    <h4>Growing prompts in each category</h4>
    <mat-tab-group>
      @for (cat of getGrowingPromptCategories(); track cat) {
      <mat-tab [label]="cat">
        <div class="prompts-table-wrapper">
          <table class="prompts-table">
            <thead>
              <tr>
                <th>Prompts</th>
                <th>Type of prompts</th>
                <th>Relevancy</th>
                <th>AI Volume</th>
              </tr>
            </thead>
            <tbody>
              @for (row of getGrowingPromptsForCategory(cat); track $index) {
              <tr>
                <td>{{ row.prompt }}</td>
                <td>{{ getPromptTypeDisplay(row) }}</td>
                <td>{{ row.relevancy ?? '-' }}</td>
                <td>{{ row.ai_volume ?? '-' }}</td>
              </tr>
              }
            </tbody>
          </table>
        </div>
      </mat-tab>
      }
    </mat-tab-group>
  </div>
  }
</div>
}
